import React from "react";
import { Projects } from "../../Data/Data";
import FeaturedProject from "./FeaturedProject";
import LatestRepo from "./LatestRepo";

const Project = () => {
  return (
    <section className="featured__work" id="Project">
      <h2>Some of my Project</h2>
      <ul>
        {Projects.map(({ content, link, repo, image, imageDetails }) => (
          <li>
            <FeaturedProject
              content={content}
              link={link}
              repo={repo}
              image={image}
              imageDetails={imageDetails}
            />
          </li>
        ))}
      </ul>
      <LatestRepo />
    </section>
  );
};

export default Project;
